import { render } from "./CountryDesignationSelector.vue?vue&type=template&id=2c0672f0&scoped=true&ts=true"
import script from "./CountryDesignationSelector.vue?vue&type=script&lang=ts&scoped=true"
export * from "./CountryDesignationSelector.vue?vue&type=script&lang=ts&scoped=true"

import "./CountryDesignationSelector.vue?vue&type=style&index=0&id=2c0672f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0672f0"]])

export default __exports__